export class PayBreakdown {
  get totalPay(): number {
    return this.regularPay + this.otPay;
  }
  public constructor(public regularPay: number, public otPay: number = 0) { }
}
